const BaseComponent = require( 'base/base-component' );

class InqueryReverse extends BaseComponent {
  constructor(){
    super({
      events: {

      }
    })
  }
}

module.exports = InqueryReverse;
